var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SideImageLayout, StandardLayout } from 'hx-ui';
import { useSyncFormWithStore } from 'hx-wizard';
import { FormProvider, useForm } from 'react-hook-form';
import { widgetActions } from '@/store';
import { UserDetailsForm } from '@/components/user-details/user-details-form.component';
import { pageImages } from '@/pages/images';
import { GradientDivider } from '@/components/gradient-divider.component';
import { FormNavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { useSetProgress } from 'hx-progress';
import { useDispatch, useSelector } from 'react-redux';
import { StyledProgress } from '@/components/styled-progress.component';
import { useAnalytics } from 'hx-analytics';
import { trackCustom } from '@/events/hooks/use-lexie-event.hook';
import { isYoungerThenEighteen } from '@/components/form/helpers/get-birth-year-validation-message.helper';
import { sendScrollIntoView } from '@/helpers/send-scroll-into-view.helper';
import { useTrackLead } from '@/hooks/use-track-lead.hook';
import { getCategoryPath } from 'hx-util';
export function DetailsFormPage() {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var trackLead = useTrackLead();
    useSetProgress(2, 1);
    var category = useSelector(function (state) { return state.dinTest.result.category; });
    var _a = useAnalytics(), sendButtonClick = _a.sendButtonClick, sendCustomAnalytics = _a.sendCustomAnalytics;
    var form = useForm({
        mode: 'onChange',
    });
    useSyncFormWithStore(form, ['widget', 'userDetails'], widgetActions.setUserDetails);
    function trackUnderageBirthYear(birthYear) {
        sendCustomAnalytics({ message: birthYear, type: 'invalid-age' });
        trackCustom('under_age', { value: birthYear });
        form.setError('birth-year', {
            type: 'custom',
            message: 'You must be 18 years or older',
        });
    }
    var onSubmit = form.handleSubmit(function (values) {
        var _a;
        sendScrollIntoView();
        var birthYearInputValue = values['birth-year'];
        if (isYoungerThenEighteen(birthYearInputValue)) {
            trackUnderageBirthYear(birthYearInputValue);
            return;
        }
        sendCustomAnalytics({ message: birthYearInputValue, type: 'birth-year' });
        trackCustom('birth_year', { value: birthYearInputValue });
        if (values['health-and-member-discounts']) {
            sendCustomAnalytics({
                message: values['health-and-member-discounts'],
                type: 'health_and_member_discounts',
            });
            trackCustom('health_and_member_discounts', {
                data: values['health-and-member-discounts'],
            });
        }
        sendButtonClick('test_result');
        trackLead();
        navigate("/result-category/".concat(getCategoryPath(category)));
        (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({ type: 'host/test-complete', payload: { lead: values } }, '*');
        window.parent.postMessage({
            type: 'lx_analytics',
            event: {
                action: 'hd-lead',
                event_category: 'forms',
                event_label: 'form-lexie-widget',
                event_email: values['email'],
            },
        }, '*');
        dispatch(widgetActions.setFormSubmitted(true));
    });
    return (_jsx(SideImageLayout, { className: 'overflow-y-auto', imageLeft: pageImages.coupleSmiling, leftPanelWidth: "40%", imageStyle: {
            backgroundSize: 'cover',
            backgroundPosition: '85% 50%',
            backgroundRepeat: 'no-repeat',
        }, header: _jsx(StyledProgress, { className: "px-4 md:px-12 py-6", textClassName: 'font-bold' }), headingComponent: _jsx(Typography, __assign({ align: 'center', className: 'text-white text-2xl inline-block px-8' }, { children: _jsx("strong", { children: "Enter your contact details to get your results" }) })), content: _jsx(FormProvider, __assign({}, form, { children: _jsx("form", __assign({ onSubmit: onSubmit, className: 'md:max-w-md' }, { children: _jsx(StandardLayout, { className: "md:max-h-[553px] md:overflow-y-auto pb-6 md:px-6", content: _jsxs("div", __assign({ className: "flex flex-col gap-6 p-4 md:p-0" }, { children: [_jsxs("div", __assign({ className: "flex flex-col items-center gap-6 md:gap-4 md:sticky md:top-0 md:w-full md:bg-white md:z-10" }, { children: [_jsxs(Typography, __assign({ className: "text-3xl md:text-4xl" }, { children: [_jsx("strong", { children: "Redeem your $50 coupon" }), _jsx("span", __assign({ className: "block text-base pt-5 md:hidden" }, { children: "Enter your contact details:" }))] })), _jsx(GradientDivider, { className: "w-full" })] })), _jsx(UserDetailsForm, { form: form })] })), nav: _jsx(NavigationButtonsContainer, __assign({ className: "px-6 w-full md:w-auto" }, { children: _jsx(FormNavigationButton, { type: "submit", label: "View my results" }) })) }) })) })) }));
}
